<template>
    <div class="google-map-area section" id="support">
        <!-- <GmapMap
            :center="{lat:52.482900, lng:-1.893460}"
            :zoom="12"
            map-type-id="terrain"
        >
        </GmapMap> -->
        <div class="container map-responsive">
            <iframe title="Helios-Med Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.7121737187003!2d19.557632850645206!3d40.724352279229!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134552c9caa86f1d%3A0x9dd80419e04e9e29!2sLaboratori+Helios+Med!5e0!3m2!1sen!2s!4v1515874536836" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen="">
                
            </iframe>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import * as VueGoogleMaps from 'vue2-google-maps'
    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyB2D8wrWMY3XZnuHO6C31uq90JiuaFzGws',
        },
    
    })
    export default {
        name: 'GoogleMap',
    }
</script>
